<template lang="pug">
  crud-scroll-details.pa-2(
    ref="list"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
  )
    template(#list-item="{ item, opencu }")
      v-list-item-content
        v-list-item-title {{ item.name }}
    template(#no-select)
      div
        v-alert(type="info" outlined) Выберите элемент списка для детального отображения
        .d-flex
          //- v-btn(color="primary" outlined @click="create").ml-auto Создать новую анкету
          //-   v-icon mdi-plus
</template>
<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import ListDetail from '../components/questionare/QuestionareListDetail.vue';
import QuestionnaireCreateModal from '../components/questionare/QuestionnaireCreateModal.vue';

export default {
  components: {
    CrudScrollDetails,
  },
  props: {
  },
  data() {
    return {
      detailsComponent: {
        component: ListDetail,
        component_attrs: {},
        component_listeners: {
          update: (id) => {
            this.$refs.list.selectById(id, 'id');
          },
          deleted: () => { this.$refs.list.refreshList(); this.$refs.list.unSelect(); },
        },
      },
    };
  },
  methods: {
    create() {
      this.$modals.show('generic-controller', {
        title: 'Создание анкеты',
        component: QuestionnaireCreateModal,
        'component-props': {
          initial: {},
          success: () => {
            this.$modals.close();
            this.$refs.list.refreshList();
          },
        },

      });
    },
    adapter(params) {
      const extend = {
        ...params,
        'search[organization_id]': this.$user.organization.id,
        // is_requestable === [org_ids]
        expand: 'organizations,questions,questionnaire_user,mentoring_categories',
      };
      return this.$api.mentoring.getQuestionnaires(extend);
    },
  },
};
</script>
